import { render, staticRenderFns } from "./centered.vue?vue&type=template&id=d0cd51d6"
import script from "./centered.vue?vue&type=script&lang=ts"
export * from "./centered.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports